import { defineMessages } from 'react-intl'

const scope =
  'platform.banking.features.listExternalBankAccountConfigs.views.externalBankAccountConfigTable'

export default defineMessages({
  tableAriaLabel: {
    id: `${scope}.tableAriaLabel`,
    defaultMessage: 'Bank accounts',
  },
  emptyStateTitle: {
    id: `${scope}.emptyStateTitle`,
    defaultMessage: 'No accounts found',
  },
  errorStateText: {
    id: `${scope}.errorStateText`,
    defaultMessage: 'Failed to load bank accounts. Please try again.',
  },
  columnAccountName: {
    id: `${scope}.columnAccountName`,
    defaultMessage: 'Account name',
  },
  columnPaymentMethod: {
    id: `${scope}.columnPaymentMethod`,
    defaultMessage: 'Payment method',
  },
  columnDetails: {
    id: `${scope}.columnDetails`,
    defaultMessage: 'Details',
  },
  columnGlCode: {
    id: `${scope}.columnGlCode`,
    defaultMessage: 'GL code',
  },
  columnCurrency: {
    id: `${scope}.columnCurrency`,
    defaultMessage: 'Currency',
  },
  typeOther: {
    id: `${scope}.typeOther`,
    defaultMessage: 'Other',
  },
  typeCheck: {
    id: `${scope}.typeCheck`,
    defaultMessage: 'Check',
  },
  typeAch: {
    id: `${scope}.typeAch`,
    defaultMessage: 'ACH',
  },
  typeEft: {
    id: `${scope}.typeEft`,
    defaultMessage: 'EFT',
  },
  typeWire: {
    id: `${scope}.typeWire`,
    defaultMessage: 'Wire',
  },
  detailDescription: {
    id: `${scope}.detailDescription`,
    defaultMessage: 'Description',
  },
  detailStartNumber: {
    id: `${scope}.detailStartNumber`,
    defaultMessage: 'Check numbers start at',
  },
  detailBankName: {
    id: `${scope}.detailBankName`,
    defaultMessage: 'Bank name',
  },
  detailBankRoutingNumber: {
    id: `${scope}.detailBankRoutingNumber`,
    defaultMessage: 'Bank routing number',
  },
  detailCompanyName: {
    id: `${scope}.detailCompanyName`,
    defaultMessage: 'Company name',
  },
  detailCompanyRoutingNumber: {
    id: `${scope}.detailCompanyRoutingNumber`,
    defaultMessage: 'Company account number',
  },
  detailCompanyTaxId: {
    id: `${scope}.detailCompanyTaxId`,
    defaultMessage: 'Company tax ID',
  },
  accountActionsAriaLabel: {
    id: `${scope}.accountActionsAriaLabel`,
    defaultMessage: 'Actions for {name}',
  },
  deleteAccountAction: {
    id: `${scope}.deleteAccountAction`,
    defaultMessage: 'Delete account',
  },
  sortAccountName: {
    id: `${scope}.sortAccountName`,
    defaultMessage: 'Account name',
  },
  sortCurrency: {
    id: `${scope}.sortCurrency`,
    defaultMessage: 'Currency',
  },
  sortPaymentMethod: {
    id: `${scope}.sortPaymentMethod`,
    defaultMessage: 'Payment method',
  },
})
